import React, { useState, useEffect } from 'react';
import { useLang } from '../i18n/LanguageContext';
import { Globe, X } from 'lucide-react';

const COPY = {
  en: { msg: 'Prefer English? View this site in English.', cta: 'Switch to English' },
  ar: { msg: 'تفضّل العربية؟ تصفّح الموقع بالعربية.', cta: 'العربية' },
  it: { msg: 'Preferisci l\'italiano? Visita il sito in italiano.', cta: 'Passa all\'italiano' },
};

const LangSuggestBanner = () => {
  const { lang, switchLang } = useLang();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (lang !== 'fr') return;
    if (localStorage.getItem('partyledLangBannerDismissed')) return;
    if (localStorage.getItem('partyledLang')) return; // l'utilisateur a déjà choisi
    const nav = (navigator.language || '').toLowerCase();
    if (nav.startsWith('ar')) setTarget('ar');
    else if (nav.startsWith('it')) setTarget('it');
    else if (nav.startsWith('en')) setTarget('en');
  }, [lang]);

  if (!target) return null;
  const c = COPY[target];
  const dismiss = () => {
    localStorage.setItem('partyledLangBannerDismissed', '1');
    setTarget(null);
  };
  const accept = () => { dismiss(); switchLang(target); };

  return (
    <div
      dir={target === 'ar' ? 'rtl' : 'ltr'}
      className="fixed top-20 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-xl"
      data-testid="lang-suggest-banner"
    >
      <div className="flex items-center gap-3 bg-[#141418]/95 backdrop-blur border border-purple-500/30 rounded-full pl-5 pr-3 py-2.5 shadow-xl">
        <Globe className="w-4 h-4 text-purple-400 shrink-0" />
        <span className="text-gray-200 text-sm flex-1">{c.msg}</span>
        <button
          onClick={accept}
          className="bg-purple-600 hover:bg-purple-500 text-white text-xs font-medium px-4 py-1.5 rounded-full transition-colors shrink-0"
          data-testid="lang-suggest-accept"
        >
          {c.cta}
        </button>
        <button onClick={dismiss} className="text-gray-500 hover:text-white p-1 shrink-0" aria-label="Fermer" data-testid="lang-suggest-close">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default LangSuggestBanner;
